/* global GLightbox */

document.addEventListener('DOMContentLoaded', function () {
	const imageLinks = document.querySelectorAll('.prose a > img');

	if (!imageLinks.length) {
		return;
	}

	imageLinks.forEach(function (img) {
		const link = img.closest('a');

		if (link) {
			link.classList.add('glightbox', 'prose__media-link');
			link.setAttribute('data-glightbox', '');
		}
	});

	GLightbox({
		selector: '.prose a.glightbox',
	});
});
